export default {
      id: "other-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "img/icons.svg#other",
      toString: function () {
        return this.url;
      }
    }